// extracted by mini-css-extract-plugin
export default {"wrapperSelect":"SeminarianSelectionForConferenceTypeCustomizable_wrapperSelect__KZrYR","select":"SeminarianSelectionForConferenceTypeCustomizable_select__tUnj4"};